import { render, staticRenderFns } from "./roleTable.vue?vue&type=template&id=1f6d99ab&scoped=true&"
import script from "./roleTable.vue?vue&type=script&lang=js&"
export * from "./roleTable.vue?vue&type=script&lang=js&"
import style0 from "./roleTable.vue?vue&type=style&index=0&id=1f6d99ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6d99ab",
  null
  
)

export default component.exports